import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Providers } from '@/app/Providers';
import { router } from '@/app/router';

// Before the stylesheet, so the @font-face rules exist by the time the theme
// references them. Both families ship every subset with a unicode-range, so
// importing the package does not mean downloading all of it.
import '@fontsource-variable/onest';
import '@fontsource-variable/sora';

import '@/styles/index.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element #root is missing from index.html.');
}

createRoot(container).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={router} />
    </Providers>
  </StrictMode>,
);
